<template>
  <div>
    <Breadcrumbs main="Inventario" title="Syncronizar Despacho" v-if="objectId"/>
    <Breadcrumbs main="Inventario" title="Agregar Despacho" v-else/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 v-if="objectId">Sincronizar Despacho  - {{lastCode}}</h5>
              <h5 v-else>Agregar Despacho</h5>
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <div class="col-4 mb-3">
                    <label for="client_id">Cliente (requerido)</label>
                    <multiselect placeholder="Selecciona un cliente" id="client_id"
                                 label="business_name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.client.value" :options="form.client.options"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                                 @input="getWithOutTreeCategory(categoryField, form.client.value.id)">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay clientes disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.client.is_valid">{{form.client.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label >Código de seguimiendo (opcional)</label>
                    <b-form-input
                            type="text" id="tracking_code_id"
                            :readonly="form.tracking_code.readonly"
                            v-model="form.tracking_code.value">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.tracking_code.is_valid">{{form.tracking_code.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label>Código de despacho (automático)</label>
                    <b-form-input
                            type="text" id="code_id" placeholder="0" min="0" readonly
                            v-model="form.code.value">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.code.is_valid">{{form.code.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-4 mb-3">
                    <label for="type_dispatch_id">Tipo de Compra (requerido)</label>
                    <multiselect placeholder="Selecciona un cliente" id="type_dispatch_id"
                                 label="name" track-by="id"
                                 :disabled="form.type.readonly"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.type.value" :options="form.type.options"
                                 @input="setCode"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay clientes disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.type.is_valid">{{form.type.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-3 mb-3">
                    <label for="type_dispatch_id">Despacho Urgente (requerido)</label>
                    <multiselect placeholder="Selecciona un tipo"
                                 label="name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.is_urgent.value" :options="form.is_urgent.options"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay clientes disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.is_urgent.is_valid">{{form.is_urgent.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-5 mb-3">
                    <label for="dispatch_client_id">Persona (requerido)</label>
                    <multiselect placeholder="Selecciona un cliente" id="dispatch_client_id"
                                 label="name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.dispatch_client.value" :options="form.dispatch_client.options"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                                 @input="setDispatchClient(form.dispatch_client)"
                                 @search-change="getClientDispatchFilter"
                                 :loading="isLoadingDispatchClient"
                    >
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay clientes disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.dispatch_client.is_valid">{{form.dispatch_client.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="row" v-show="form.dispatch_client.value && form.client.value && (form.type.value.id === 'SD' || form.tracking_code.value !== '' )">
                    <div class="col-md-4 mb-3">
                      <label>Nombres (requerido)</label>
                      <b-form-input
                              type="text" id="name_id"
                              v-model="form.name.value">
                      </b-form-input>
                      <b-form-invalid-feedback :state="form.name.is_valid">{{form.name.message_error}}</b-form-invalid-feedback>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Email (opcional)</label>
                      <b-form-input
                              type="email" id="email_id"
                              v-model="form.email.value">
                      </b-form-input>
                      <b-form-invalid-feedback :state="form.email.is_valid">{{form.email.message_error}}</b-form-invalid-feedback>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Teléfono (opcional)</label>
                      <masked-input class="form-control" id="username_id"
                                    v-model="form.phone.value"
                                    placeholder="+569 1234 5678"
                                    :mask="maskPhone"
                      />
                      <b-form-invalid-feedback :state="form.phone.is_valid">{{form.phone.message_error}}</b-form-invalid-feedback>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="region_id">Región (requerido)</label>
                      <multiselect placeholder="Selecciona una región" id="region_id"
                                   label="name" track-by="id"
                                   deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                   v-model="form.region.value" :options="form.region.options"
                                   :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                                   @input="getCommune(form.commune, form.region.value.id)">
                        <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                        <template slot="noOptions">No hay elementos en esta lista.</template>
                      </multiselect>
                      <b-form-invalid-feedback :state="form.region.is_valid">{{form.region.message_error}}</b-form-invalid-feedback>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="parent_id">Comuna (requerido)</label>
                      <multiselect placeholder="Selecciona una comuna" id="parent_id"
                                   label="name" track-by="id"
                                   deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                   v-model="form.commune.value" :options="form.commune.options"
                                   :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                        <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                        <template slot="noOptions">Debe seleccionar una región.</template>
                      </multiselect>
                      <b-form-invalid-feedback :state="form.commune.is_valid">{{form.commune.message_error}}</b-form-invalid-feedback>
                    </div>
                    <div class="col-md-12 mb-3">
                      <label for="address_id">Dirección (requerido)</label>
                      <gmap-autocomplete  class="form-control" placeholder="Av. Siempre viva #1111" id="address_id"
                                          autocomplete="true"
                                          :options="optionsAutocomplete" :value="form.address.value"
                                          @place_changed="setPlace">
                      </gmap-autocomplete >
                      <b-form-invalid-feedback :state="form.address.is_valid">{{form.address.message_error}}</b-form-invalid-feedback>
                    </div>
                    <div class="col-md-12 mb-3">
                      <label>Observaciones de dirección (opcional - Se verá reflejado en la guía de despacho)</label>
                      <b-form-textarea rows="3"
                                       v-model="form.observation.value" placeholder="Departamento 123."></b-form-textarea>
                      <b-form-invalid-feedback :state="form.observation.is_valid">{{form.observation.message_error}}</b-form-invalid-feedback>
                    </div>
                    <div class="col-md-12 mb-3">
                      <label>Observaciones de despacho (opcional)</label>
                      <b-form-textarea rows="3"
                                       v-model="form.additional_observation.value" placeholder="Dejar en conserjería."></b-form-textarea>
                      <b-form-invalid-feedback :state="form.additional_observation.is_valid">{{form.additional_observation.message_error}}</b-form-invalid-feedback>
                    </div>
                    <div class="col-md-12 mb-3">
                      <GmapMap style="width: 100%; height: 500px"
                               v-if="form.dispatch_client.value && form.client.value && (form.type.value.id === 'SD' || form.tracking_code.value !== '' )"
                               :center="optionsMap.center"
                               :zoom="optionsMap.zoom">
                        <GmapMarker
                                :key="mark.lat"
                                v-for="mark in marker"
                                :position="{ lat: mark.position.lat, lng: mark.position.lng}" />
                      </GmapMap>
                    </div>
                  </div>
                </div>
              </b-form>
              <div class="col-12 mb-5" v-show="form.dispatch_client.value && form.client.value && (form.type.value.id === 'SD' || form.tracking_code.value !== '' )">
                <a class="pull-right" href="javascript:void(0);" title="Apregar producto" v-on:click="addProduct(form.dispatchproduct_set, productId)">
                  <span class="badge badge-success"><i class="fa fa-plus"></i> Agregar producto</span>
                </a>
              </div>
              <div v-for="product in form.dispatchproduct_set" class="row" :key="product.id.value-123" v-show="form.dispatch_client.value && form.client.value && (form.type.value.id === 'SD' || form.tracking_code.value !== '' )" v-on:mouseenter="setLastRowSelected(product)">
                <div class="col-4 mb-3">
                  <label>Categoría (requerido)</label>
                  <multiselect placeholder="Selecciona una categoría"
                               label="name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="product.category.value" :options="product.category.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                               @input="setProductByCategory(product, product.category.value.id)">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                    <template slot="noOptions">No hay elementos en esta lista.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="product.category.is_valid">{{product.category.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-4 mb-3">
                  <label>Producto (requerido)</label>
                  <multiselect placeholder="Selecciona un producto"
                               label="small_name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="product.product.value" :options="product.product.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                               @input="setProductFilter(form.dispatchproduct_set, product)">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                    <template slot="noOptions">No hay elementos en esta lista.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="product.product.is_valid">{{product.product.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-3 mb-3">
                  <label>Stock (requerido)</label>
                  <b-form-input
                          type="number" min="1"
                          v-model="product.stock.value">
                  </b-form-input>
                  <a href="javascript:void(0);" class="mr-2" title="Actualizar stock" v-on:click="setProductByCategory(product, product.category.value.id, product.product.value.id)">
                    <span class="badge badge-primary mt-2" v-if="product.product.value !== ''"><i class="fa fa-refresh"></i></span>
                  </a>
                  <span class="badge badge-success mt-2" v-if="product.product.value !== ''">{{product.product.value.invoice_stock}} disponible(s)</span>
                  <b-form-invalid-feedback :state="product.stock.is_valid">{{product.stock.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-1-mb-3">
                  <button type="button" class="btn btn-danger m-t-30" v-on:click="deleteProduct(form.dispatchproduct_set, product.id.value)"><i class="fa fa-times"></i></button>
                </div>
              </div>
              <div class="col-12 mb-5 mt-5" v-show="form.dispatch_client.value && form.client.value && (form.type.value.id === 'SD' || form.tracking_code.value !== '' )">
                <a class="pull-right" href="javascript:void(0);" title="Apregar producto" v-on:click="addProduct(form.dispatchproduct_set, productId)">
                  <span class="badge badge-success"><i class="fa fa-plus"></i> Agregar producto</span>
                </a>
              </div>
              <div class="row">
                <b-button type="button" variant="success" @click="onSubmit" v-show="form.dispatch_client.value && form.client.value && (form.type.value.id === 'SD' || form.tracking_code.value !== '' )">Agregar despacho</b-button>
                <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'InventoryDispatchList'}">Volver</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import Multiselect from 'vue-multiselect';
  import utils from '../../../utils';
  import MaskedInput from "vue-masked-input";

  export default {
    components: {
      MaskedInput,
      Multiselect
    },
    data(){
      return {
        objectId: null,
        lastCode: null,
        maskPhone: {
          pattern: '+### #### ####',
          formatCharacters: {
            '#': {
              validate: char => /[0-9]/.test(char),
            },
          },
        },
        // INTERVALO PARA QUE ACTUALICE EL CÓDIGO CADA 10 SEGUNDOS
        interval: 10,
        // ID PARA CUANDO GENERO LAS FILAS DE PRODUCTOS
        productId: 1,
        // FIELD PARA OBTENER LAS CATEGORÍAS
        categoryField: utils.defaultFields({_type: 'select'}),
        // PARA OBTENER EL ÚLTIMO PRODUCTO SELECCIONADO
        lastProductSelected: null,
        lastCategorySelected: null,
        lastRow: null,
        isLoadingDispatchClient: true,
        form: {
          code: utils.defaultFields(),
          type: utils.defaultFields(
                  {
                    _type: 'select',
                    options: utils.typeDispatch,
                    value: utils.typeDispatch.find(options => options['id'] === 'BO'),
                  }
          ),
          tracking_code: utils.defaultFields({value: ''}),
          client: utils.defaultFields({
            _type: 'select',
          }),
          // dispatch_client: utils.defaultFields(),
          dispatch_client: utils.defaultFields({_type: 'select'}),
          name: utils.defaultFields(),
          email: utils.defaultFields({required: false}),
          phone: utils.defaultFields({required: false}),
          region: utils.defaultFields(),
          commune: utils.defaultFields({ _type: 'select'}),
          address: utils.defaultFields(),
          lat: utils.defaultFields(),
          lng: utils.defaultFields(),
          observation: utils.defaultFields({required: false}),
          additional_observation: utils.defaultFields({required: false}),
          is_urgent: utils.defaultFields({
            _type: 'select',
            options: [
              {'id': true, 'name': 'Si'},
              {'id': false, 'name': 'No'},
            ],
            value: {'id': false, 'name': 'No'}
          }),
          dispatchproduct_set: [
            {
              id: utils.defaultFields({value: 0}),
              category: utils.defaultFields({_type: 'select'}),
              // ESTOS SON NECESARIOS
              product: utils.defaultFields({_type: 'select'}),
              stock: utils.defaultFields(),
            }
          ]
        },
        marker: [],
        place: '',
        optionsAutocomplete: {
          componentRestrictions: {
            country: [
              'cl',
            ],
          },
        },
        optionsMap: {
          center: {
            lat: -33.4488897,
            lng: -70.6692655
          },
          zoom: 12
        }
      }
    },
    async mounted () {
      this.objectId = this.$route.params.objectId;
      this.getCode(this.form.code);
      this.interval = setInterval(() => {
        this.getCode(this.form.code);
      }, this.interval * 1000);
      this.getRegion(this.form.region);
      await this.getClient(this.form.client);
      await this.getClientDispatch(this.form.dispatch_client);
      if(this.objectId){
        await this.loadData(this.objectId);
      }
    },
    beforeDestroy () {
      clearInterval(this.interval);
    },
    methods: {
      onSubmit(evt){
        // console.log(evt)
        evt.preventDefault();
        // AQUÍ GUARDARÉ EL JSON FINAL PARA QUE SEA ENVIADO AL POST
        let data = {};
        const is_valid = utils.generateJsonStructure(this.form, data);
        if(is_valid){
          let _type = 'agregar un despacho';
          if(this.objectId){
            _type = `agregar un despacho syncronizado con la guía <b>${this.lastCode}</b>`;
            // AGREGO LA LLAVE DEL QUE SE ESTÁ SINCRONIZANDO
            data['sync_dispatch'] = this.objectId;
          }
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de ${_type}.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              const path = '/api/inventory/v1.0/dispatch/';
              await axios.post(path, data).then(async () => {
                // console.log(response);
                await this.$swal({
                  title: 'Agregado',
                  type: 'success',
                  html: `Se ha agregado el despacho con código <b>${this.form.code.value}</b> de manera correcta.`,
                }).then(() => {
                  this.$router.push({'name': 'InventoryDispatchList'});
                });
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                console.log(error.response);
                if(error.response.status === 400){
                  utils.generateBackendError(this.form, error.response.data);
                  await this.$swal({
                    title: 'Error',
                    type: 'error',
                    html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                  });
                }
              });
            }
          });
        } else {
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
      },
      // PARA INHABILITAR
      setCode(){
        // CUANDO ES SIN DOCUMENTO
        if(this.form.type.value.id === 'SD'){
          this.form.tracking_code.readonly = true;
          this.form.tracking_code.required = false;
          this.form.tracking_code.value = '';
        } else {
          this.form.tracking_code.readonly = false;
          this.form.tracking_code.required = true;
        }
      },
      async getClient(clientField){
        const path = '/api/core/v1.0/client/';
        const filter = {
          status: true,
          deleted: false
        };
        await axios.get(path, {params: filter}).then((response) => {
          if(response.status === 200){
            clientField.options = response.data;
            // clientField.value = clientField.options.find(option => clientField.value === option.id);
          }
        });
      },
      async getClientDispatch(clientDispatchField, params = {}) {
        const path = '/api/core/v1.0/client_dispatch/';
        await axios.get(path, { params }).then((response) => {
          if(response.status === 200){
            clientDispatchField.options = [
              {
                "id": "--",
                "name": "Cliente nuevo...",
                "email": "",
                "phone": "",
                "commune": "",
                "address": "",
                "lat": "",
                "lng": "",
                "observation": ""
              }
            ];
            response.data['results'].forEach(options => clientDispatchField.options.push(options));
            this.isLoadingDispatchClient = false;
          }
        });
      },
      async getClientDispatchFilter(query) {
        this.isLoadingDispatchClient = true;
        await this.getClientDispatch(this.form.dispatch_client, { name: query });
      },
      async setDispatchClient(DispatchClient){
        if(DispatchClient.value.id === '--'){
          this.form.name.value = '';
          this.form.observation.value = '';
          this.form.email.value = '';
          this.form.phone.value = '';
          this.form.commune.value = '';
          this.form.address.value = '';
          this.form.lat.value = '';
          this.form.lng.value = '';
          this.optionsMap.center = {
            lat: -33.4488897,
            lng: -70.6692655
          };
          this.marker = [];
          // SETIAMOS LA REGION COMO METROPOLITANA
          this.form.region.value = await this.form.region.options.find(item => item['name'] === 'Metropolitana de Santiago');
          await this.getCommune(this.form.commune, this.form.region.value['id']);
        } else {
          this.form.name.value = DispatchClient.value['name'];
          this.form.observation.value = DispatchClient.value['observation'];
          this.form.email.value = DispatchClient.value['email'];
          this.form.phone.value = DispatchClient.value['phone'];
          this.form.region.value = this.form.region.options.find(options => options['id'] === DispatchClient.value['region']['id']);
          await this.getCommune(this.form.commune, DispatchClient.value['region']['id']);
          this.form.commune.value = this.form.commune.options.find(options => options['id'] === DispatchClient.value['commune']);
          this.form.address.value = DispatchClient.value['address'];
          this.form.lat.value = DispatchClient.value['lat'];
          this.form.lng.value = DispatchClient.value['lng'];
          this.optionsMap.center = {
            lat: parseFloat(DispatchClient.value['lat']),
            lng: parseFloat(DispatchClient.value['lng'])
          };
          this.marker = [
            {
              position: {
                lat: parseFloat(DispatchClient.value['lat']),
                lng: parseFloat(DispatchClient.value['lng'])
              }
            }
          ];
        }
      },
      async getCommune(commune_field, region_id){
        const path = '/api/core/v1.0/commune/';
        await axios.get(path, {params: {region: region_id}}).then((response) => {
          if(response.status === 200){
            commune_field.options = response.data;
          }
        });
      },
      addProduct(listProducts, id){
        listProducts.push(
                {
                  id: utils.defaultFields({value: id}),
                  // PARA CLONAR
                  category: Object.assign({}, this.categoryField),
                  // ESTOS SON NECESARIOS
                  product: utils.defaultFields({_type: 'select'}),
                  stock: utils.defaultFields(),
                }
        );
        this.productId++;
      },
      deleteProduct(listProducts, id){
        if(listProducts.length > 1){
          // INDEX DE LA FILA A ELIMINAR
          const index = listProducts.findIndex(item => item['id'].value === id);
          // ELEMENTO A ELIMINAR
          const element = listProducts[index];
          this.form.dispatchproduct_set.forEach((item) => {
            // BUSCO TODAS LAS FILAS QUE TIENEN ESA CATEGORÍA
            if(item['category']['value']['id'] === element['category']['value']['id']){
              // SI TIENEN LA MISMA CATEGORÍA, SE AGREGA COMO UNA NUEVA SELECCIÓN Y VALIDO QUE HAYA ALGO SELECCIONADO
              if(element['product']['value']){
                item['product'].options.push(
                        element['product']['value']
                );
              }
            }
          });
          listProducts.splice(index, 1);
        }else{
          this.$swal({
            type: 'error',
            title: 'No puedes eliminar este producto.',
            html: `No se puede eliminar, debido a que debes tener como mínimo 1 producto a despachar.`,
          }).then(() => {
            this.place = null;
            this.$forceUpdate();
          });
        }
      },
      getCode(codeField){
        const path = '/api/inventory/v1.0/dispatch_code/';
        axios.get(path).then((response) => {
          if(response.status === 200){
            codeField.value = response.data['code'];
          }
        });
      },
      getRegion(region_field){
        const path = '/api/core/v1.0/region/';
        axios.get(path).then((response) => {
          if(response.status === 200){
            region_field.options = response.data;
          }
        }).catch((error) => {
          console.log(error.response);
        });
      },
      setPlace(place) {
        if(place) {
          this.place = place;
          this.form.address.value = place.formatted_address;
          this.form.lat.value = this.place.geometry.location.lat();
          this.form.lng.value = this.place.geometry.location.lng();
          this.marker = [
            {
              position: {
                lat: this.place.geometry.location.lat(),
                lng: this.place.geometry.location.lng(),
              }
            }
          ];
          this.optionsMap.center = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          };
        }
      },
      setLastRowSelected(lastRow){
        this.lastCategorySelected = lastRow['category']['value'];
        this.lastProductSelected = lastRow['product']['value'];
        this.lastRow = lastRow;
      },
      setProductFilter(listProductField, selectedValue){
        // SI HABÍA UN ELEMENTO SELECCIONADO PREVIAMENTE
        if(this.lastProductSelected !== ''){
          // BUSCO TODOS LOS PRODUCTOS QUE PERTEZCAN A LA MISMA CATEGORÍA DEL ÚLTI MPRODUCTO SELECCIONADO Y LO AGREGO COMO OPCIÓN EXCEPTUANDO DEL QUE SE DESELCCIONÓ
          listProductField.forEach((item) => {
            if(item['category']['value']['id'] === this.lastRow['category']['value']['id'] && item['id']['value'] !== this.lastRow['id']['value']){
              item['product'].options.push(
                      this.lastProductSelected
              );
            }
          });
        }
        // SE BORRA EL QUE SE SELECCIONÓ AHORA
        listProductField.forEach(function (item) {
          // SI LAS CATEGORÍAS SON IGUALES Y  NO ESTAMOS HABLANDO DEL MISMO SELECT EN EL QUE SE SELECCIONÓ
          if(item['category']['value']['id'] === selectedValue['category']['value']['id'] && item['id']['value'] !== selectedValue['id']['value']){
            const index = item['product'].options.findIndex(item => item['id'] === selectedValue['product']['value']['id']);
            if(index !== -1){
              item['product'].options.splice(index, 1);
            }
          }
        });
      },
      // PARA LIMPIAR EL V-FOR DE LOS PRODUCTOS
      cleanProducts(productsField, id){
        while(productsField.length !== 0){
          productsField.splice(0, 1);
        }
        this.addProduct(productsField, id);
      },
      async setProductByCategory(productRow, categoryId, defaultValue=null){
        const path = '/api/inventory/v1.0/product/';
        const config = {
          params: {
            category: categoryId,
            status: true,
            deleted: false
          }
        };
        await axios.get(path, config).then((response) => {
          if(response.status === 200){
            // VACÍO LOS OPTIONS
            productRow.product.options = [];
            // TENGO LAS OPCIONES
            let options = response.data;
            // CUANDO SON IGUALES ES PORQ SE ACTUALIZA EL STOCK DEL PRODUCTO O NO HABÍA NINGUNO SELECCIONADO
            // GUARDO TODAS LOS PRODUCTOS SELECCIONADOS DE LA CATEGORÍA
            let selected = [];
            // BUSCO ALGÚN SELECT QUE TENGA LA CATEGORÍA
            for(let i = 0; i < this.form.dispatchproduct_set.length; i++){
              // SI SON LA MISMA CATEGORÍA
              if(this.form.dispatchproduct_set[i]['category']['value']['id'] === categoryId){
                // VALIDO QUE HAYA ALGO SELECCIONADO
                if(this.form.dispatchproduct_set[i]['product']['value']['id']){
                  // CUANDO ES DISTINTO A NULO ES PORQ SOLO QUIERO ACTUALIZAR
                  // VALIDO QUE LA FILA QUE QUIERO ACTUALIZAR NO SE LE QUITE EL VALOR SELECCIONADO
                  if(defaultValue === null || productRow['id']['value'] !== this.form.dispatchproduct_set[i]['id']['value']){
                    selected.push(
                            this.form.dispatchproduct_set[i]['product']['value']['id']
                    );
                  }
                }
              }
            }
            // PARA RECUPERAR EL VALOR SELECCIONADO APRA CUANDO CAMBIO DE CATEGORÍA
            if(this.lastProductSelected !== ''){
              // BUSCO ALGÚN SELECT QUE TENGA LA CATEGORÍA ANTERIOR
              for(let i = 0; i < this.form.dispatchproduct_set.length; i++){
                // VALIDO QUE HAYA UNA ÚLTIMA CATEGORÍA SELECCIONADA
                if(this.lastCategorySelected != null){
                  // SI SON LA MISMA CATEGORÍA
                  if(this.form.dispatchproduct_set[i]['category']['value']['id'] === this.lastCategorySelected['id'] && defaultValue === null){
                    // A SUS OPCIONES LE AGREGO EL ELEMENTO SELECCIONADO DE LA CATEGORÍA CAMBIADA
                    this.form.dispatchproduct_set[i]['product'].options.push(
                            this.lastProductSelected
                    );
                  }
                }
              }
            }
            // RECORRO TODAS LAS OPCIONES SELECCIONADAS
            selected.forEach((item) => {
              // LA QUITO DE LAS OPCIONES SELECCIONABLES
              const index = options.findIndex(option => option['id'] === item);
              if(index !== -1){
                options.splice(index, 1);
              }
            });
            productRow.product.options = options;
            if(defaultValue !== null){
              productRow.product.value = productRow.product.options.find(item => item['id'] === defaultValue);
            }else{
              productRow.product.value = '';
            }
          }
        });
      },
      async getWithOutTreeCategory(inputCategory, clientId){
        const path = `/api/inventory/v1.0/category_without_tree/`;
        const config = {
          params: {
            client_id: clientId,
          }
        };
        await axios.get(path, config).then(async (response) => {
          inputCategory.options = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
        this.cleanProducts(this.form.dispatchproduct_set, this.productId);
      },
      async loadData(objectId){
        let responseData;
        const path = `/api/inventory/v1.0/dispatch/${objectId}/`;
        axios.get(path).then(async (response) => {
          responseData = response.data;
          // OBTENGO EL CÓDIGO DE LA GUÍA
          this.lastCode = responseData['code'];
          // GENERO LOS VALORES POR DEFECTO
          this.form.client.value = await this.form.client.options.find(item => item['id'] === responseData['client']['id']);
          // GATILLAMOS EL CAMBIO DEL CLIENTE
          await this.getWithOutTreeCategory(this.categoryField, this.form.client.value.id);
          this.form.tracking_code.value = (responseData['tracking_code'] !== null) ? responseData['tracking_code'] : '';
          this.form.tracking_code.readonly = true;
          this.form.type.value = await this.form.type.options.find(item => item['id'] === responseData['type']);
          if(responseData['type'] === 'SD'){
            this.form.tracking_code.required = false;
          }
          this.form.type.readonly = true;
          this.form.dispatch_client.value = this.form.dispatch_client.options.find(item => item['id'] === responseData['dispatch_client']['id']);
          // AGREGAMOS LA OBSERVACIÓN ADICIONAL
          this.form.additional_observation.value = responseData['additional_observation'];
          // AGREGAMOS SI EL DESPACHO ES URGENTE
          this.form.is_urgent.value = this.form.is_urgent.options.find(item => item['id'] === responseData['is_urgent']);
          // PARA GATILLAR EL CAMBIO DE CLIENTE Y OBTENER LA DATA
          this.setDispatchClient(this.form.dispatch_client);
          // GENERO UN CONTADOR
          let cont = 0;
          // GENERO LA FILA DEL PRODUCTO COPIANDO LA CREADA POR DEFECTO
          const row = Object.assign({}, this.form.dispatchproduct_set[0]);
          this.form.dispatchproduct_set = [];
          // ASIGNO LA DATA DE LA ESTRUCTURA CARGA
          responseData['dispatchproduct_set'].forEach(async (item) => {
            // VOY AGREANDO ELEMENTOS
            const _row = Object.assign({}, row);
            // ASIGNAMOS EL CONTADOR
            _row['id'].value = cont;
            // SELECCIONAMOS LA CATEGORÍA
            _row['category'].value = await _row['category'].options.find(_item => _item['id'] === item['category_id']);
            // GATILLO LOS CAMBIOS DE CATEGORIÁS PARA TENER EL PRODUCTO
            await this.setProductByCategory(_row, item['category_id']);
            // SELECCIONAMOS EL PROCUCTO
            _row['product'].value = await _row['product'].options.find(_item => _item['id'] === item['product']);
            // CAMBIO EL STOCK INICIAL
            _row['stock'].value = item['stock'];
            // GATILLO EL CAMBIO
            this.setProductFilter(this.form.dispatchproduct_set, _row);
            // LO AGREGO AL FORMUALRIO
            this.form.dispatchproduct_set.push(
                    _row
            );
            // SUMO EL CONTADOR
            cont++;
          });
        }).catch((error) => {
          console.log(error.response);
        });
      }
    }
  }
</script>

<style>
  .multiselect, .multiselect__input, .multiselect__single {
    font-family: inherit;
    font-size: 14px !important;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }
</style>
